<template>
  <div>
    <div class="button-g">
      <div class="btn-square" @click="show('data')" :class="{ 'active': data }">データ</div>
      <div class="btn-square" @click="show('history')" :class="{ 'active': history }">対応履歴</div>
      <div class="btn-square" @click="show('map')" :class="{ 'active': map }">地図</div>
      <div class="btn-square" @click="show('card')" :class="{ 'active': card }">APカード</div>
      <div class="btn-link"><router-link :to="{ name: 'printap', exact: true }">APカード印刷</router-link></div>
      <div class="btn-square"><appointment-gmail :appointment="appointment"></appointment-gmail></div>
      <div class="btn-square"><appointment-gmail-support :appointment="appointment"></appointment-gmail-support></div>
    </div>

    <div class="flex appointment2">
      <template v-if="data">
        <div class="basic">
          <appointment-profile2 :appointment="appointment" :edit_id="edit_id"></appointment-profile2>
        </div>
      </template>
      <template v-if="history">
        <div class="basic">
          <appointment-history2 :appointment="appointment" :condition="condition" :edit_id="edit_id" type="true"></appointment-history2>
        </div>
      </template>
      <template v-if="map">
        <div class="basic">
          <appointment-map2 :appointment="appointment" :edit_id="edit_id" type="true"></appointment-map2>
        </div>
      </template>
      <template v-if="card">
        <div class="basic">
          <appointment-card :appointment="appointment" :edit_id="edit_id" type="true"></appointment-card>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    appointment: Object,
    condition: Object,
    edit_id: Object
  },

  data () {
    return {
      data: true,
      history: true,
      map: false,
      card: false
    }
  },

  methods: {
    show (col) {
      this[col] = !this[col]
    }
  },

  beforeRouteLeave (to, from, next) {
    if (this.edit_id.appointment_id === this.appointment.id) {
      alert('AP情報が編集中です')
      return
    } else if (this.condition.condition) {
      alert('対応履歴が編集中です')
      return
    } else if (this.edit_id.list_id) {
      alert('対応履歴が編集中です')
      return
    }
    next()
  }
}
</script>

<style lang='scss' scoped>
.flex {
  display: flex;
}

.appointment2 {
  &:after {
    content: "\f1b9";
    font-family: FontAwesome;
    position: absolute;
    font-size: 300px;
    top: 50%;
    left: 50%;
    margin-top: -150px;
    margin-left: -150px;
    color: #ddd;
    opacity: 0.1;
    z-index: -1;
  }
}

.button-g {
  display: flex;
  margin-bottom: 5px;
}

.btn-square {
  display: inline-block;
  font-size: 10px;
  padding: 7px 5px;
  text-decoration: none;
  background: #fff;
  color: #37474f;
  border: solid 1px #ccc;
  border-radius: 0px;
  margin-right: 1px;
  cursor: pointer;
  width: 90px;
  text-align: center;
}

.btn-link a {
  display: inline-block;
  font-size: 10px;
  padding: 7px 5px;
  text-decoration: none;
  background: #fff;
  color: #37474f;
  border: solid 1px #ccc;
  border-radius: 0px;
  margin-right: 1px;
  cursor: pointer;
  width: 90px;
  text-align: center;
  text-decoration: none;
}

.active {
  background: #37474f;
  color: #FFF;
  border: solid 1px #37474f;
}

.basic {
  max-width: 100%;
  min-width: 16%;
  flex-basis: 100%;
}
</style>



// WEBPACK FOOTER //
// AppointmentIndex2.vue?1942e323